import {findPage, deleteProduc} from "@/api/personal";

const collectionArr = {
    state: {
        Arr: []
    },
    mutations: {
        SET_ARR(state, data) {
            state.Arr = data;

        }
    },
    actions: {
        //获取用户收藏
        getCollectArr(ctx) {
            return new Promise((resolve, reject) => {
                findPage({pageSize: 0, pageNum: 0}).then(response => {
                    let arr = [];
                    for (let i = 0; i < response.data.list.length; i++) {
                        arr.push(response.data.list[i].productSkuCode);
                    }
                    ctx.commit('SET_ARR', arr);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        }
    }
}

export default collectionArr


// WEBPACK FOOTER //
// ./src/store/modules/collectionArr.js